var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKotakLogoAdgm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.014,
    height: 32.865,
    viewBox: "0 0 97.014 32.865",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1",
    transform: "translate(-6.371 -21.563)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53989",
    "data-name": "Path 53989",
    d: "M25.477,54.428c-10.527,0-19.106-7.381-19.106-16.436s8.578-16.429,19.106-16.429,19.1,7.381,19.1,16.429S36,54.428,25.477,54.428",
    fill: "#004a8f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53990",
    "data-name": "Path 53990",
    d: "M27.918,30.594l2.128.094c-1.268,8.852-9.666,9.5-13.9.923l.556-.923c4.383,2.779,9.51,3.827,11.216-.094",
    transform: "translate(9.815 9.065)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53991",
    "data-name": "Path 53991",
    d: "M14.9,24.862l4.258-1.393.188,24.1-4.633,1.573L14.9,24.862",
    transform: "translate(8.374 1.913)",
    fill: "#ed1c24",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53992",
    "data-name": "Path 53992",
    d: "M35.342,32.452h1.941c-.754-4.047-2.8-6.6-6.764-6.952q-4.955.094-8.437,5.745c-1.526,2.324-3.976,5.974-6.95,6.4-3.585.517-5.667-2.638-4.117-5.353.941-1.659,3.483-2.348,5.26-2.184.008,0,.023.008.032.008A10.4,10.4,0,0,1,20.72,31.48l.023-3.412a11.876,11.876,0,0,0-2.411-1.847,5.912,5.912,0,0,0-3.757-.626c-5.4,1.19-6.395,5.6-5.369,11.49,2.1,6.833,8.649,7.357,12.413,2.966,2.583-3.084,8.993-13.517,13.721-7.6",
    transform: "translate(2.487 3.959)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53993",
    "data-name": "Path 53993",
    d: "M44.165,38.87c3.35,0,6-1.941,6-5.291s-2.645-5.47-6-5.47-6,2.121-6,5.471S40.807,38.87,44.165,38.87Zm0-2.466c-1.589,0-2.291-1.417-2.291-2.826,0-1.589.7-3.006,2.291-3.006s2.291,1.417,2.291,3.006c0,1.409-.7,2.825-2.291,2.825Zm5.643-5.472h1.941v4.054c0,2.474.885,3.883,4.06,3.883.876,0,1.409-.18,2.113-.18L57.75,36.4c-.352,0-.712.172-1.064.172-1.056,0-1.409-.7-1.409-1.941v-3.7h2.473V28.46H55.277V24.93l-3.35,1.236v2.291h-2.12Zm20.287,7.756h3.53v-5.11h.18L76.63,38.69h4.234l-3.882-5.643,3.53-4.587H76.63L73.8,32.694h-.18V24.93l-3.53,1.236Zm-41.287,0h3.53v-5.11l2.826,5.111H39.4l-3.7-5.643,3.53-4.587H35.344l-3.006,4.234V24.93l-3.53,1.064Zm40.057,0a11.345,11.345,0,0,1-.18-2.466V32.342c0-3.178-2.291-4.234-4.939-4.234a10.357,10.357,0,0,0-4.062.7v2.473a7.16,7.16,0,0,1,3.358-.712c1.236,0,2.291.36,2.291,1.769a4.3,4.3,0,0,0-1.589-.18c-1.941,0-5.471.36-5.471,3.53,0,2.3,1.941,3.178,3.882,3.178a3.651,3.651,0,0,0,3.358-1.759c0,.525.172,1.056.172,1.581Zm-7.232-3.342c0-.885,1.056-1.236,2.291-1.236h1.409a2.347,2.347,0,0,1-2.113,2.466c-.885,0-1.589-.525-1.589-1.227",
    transform: "translate(22.521 6.044)",
    fill: "#ed1c24",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotakLogoAdgm);
export default __webpack_public_path__ + "static/media/kotak_logo_adgm.0633ca96142074fe9bb0fb226ef25ad5.svg";
export { ForwardRef as ReactComponent };